import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';

const LeadershipSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <>
    <section className="section section-light" style={{ position: 'relative', overflow: 'hidden' }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.05) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '10%',
        right: '5%',
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.05) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <h2 className="fade-in leadership-title" style={{ 
          fontSize: '2.5rem', 
          marginBottom: '1rem',
          position: 'relative',
          paddingBottom: '1.5rem',
          color: '#1a202c',
          textAlign: 'center'
        }}>
          {t('about.leadership.title')}
        </h2>
        
        <p className="subtitle fade-in" style={{ 
          maxWidth: '800px',
          margin: '0 auto 3rem',
          fontSize: '1.125rem',
          color: '#4a5568',
          textAlign: 'center'
        }}>
          {language === 'fr' 
            ? 'Notre équipe d\'experts possède une vaste expérience dans l\'instrumentation pétrochimique et est entièrement certifiée.' 
            : language === 'ar'
            ? 'يمتلك فريق الخبراء لدينا خبرة واسعة في الأجهزة البتروكيماوية وهو معتمد بالكامل.'
            : 'Our team of experts has extensive experience in petrochemical instrumentation and is fully certified.'}
        </p>
        
        <div className="leadership-card-container" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <div className="leadership-card fade-in" style={{ 
            width: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            borderRadius: 'var(--radius-lg)',
            overflow: 'hidden',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.1)',
            transition: 'transform 0.3s, box-shadow 0.3s',
            border: '1px solid rgba(255, 255, 255, 0.15)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-10px)';
            e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'var(--shadow-xl)';
          }}>
            <div style={{ 
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                flex: '1 1 250px',
                backgroundColor: 'var(--assco-gray-900)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem 1.5rem',
                position: 'relative',
                overflow: 'hidden'
              }}>
                {/* Background pattern */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cpath d='M0,0 L100,0 L100,100 L0,100 Z' fill='none' stroke='%23ffffff' stroke-opacity='0.05' stroke-width='1'/%3E%3C/svg%3E")`,
                  backgroundSize: '20px 20px',
                  opacity: 0.3
                }}></div>
                
                {/* Profile image */}
                <div style={{
                  width: '140px',
                  height: '140px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--assco-gray-800)',
                  border: '3px solid var(--assco-orange)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  fontWeight: '800',
                    color: '#1a202c',
                  marginBottom: '1.5rem',
                  position: 'relative',
                  zIndex: 2,
                  boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3)'
                }}>
                  AF
                </div>
                
                <h3 style={{ 
                  fontSize: '1.5rem',
                  color: 'white',
                  marginBottom: '0.5rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  Allaoua Felfoul
                </h3>
                
                <p style={{ 
                  color: 'var(--assco-orange)',
                  fontWeight: '600',
                  fontSize: '1rem',
                  marginBottom: '1.25rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  {language === 'fr' ? 'Directeur Général' : 
                   language === 'ar' ? 'المدير العام' : 
                   'General Manager'}
                </p>
                
                <div style={{
                  display: 'flex',
                  gap: '1rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                    </svg>
                  </a>
                  
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                    </svg>
                  </a>
                  
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </a>
                </div>
              </div>
              
              <div style={{ 
                flex: '1 1 250px',
                padding: '3rem 2rem'
              }}>
                <h4 style={{ 
                  fontSize: '1.125rem',
                  fontWeight: '600',
                  marginBottom: '1.25rem',
                    color: '#1a202c',
                  position: 'relative',
                  paddingBottom: '0.75rem'
                }}>
                  {language === 'fr' ? 'Parcours Professionnel' : 
                   language === 'ar' ? 'المسار المهني' : 
                   'Professional Background'}
                  <span style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '50px',
                    height: '3px',
                    backgroundColor: 'var(--assco-orange)',
                    borderRadius: '1.5px'
                  }}></span>
                </h4>
                
                <div className="career-timeline">
                  <div className="timeline-item" style={{
                    display: 'flex',
                    marginBottom: '1.5rem',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-orange)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        {language === 'fr' ? 'Mai 2025' : language === 'ar' ? 'مايو 2025' : 'May 2025'}
                      </div>
                      <div style={{ 
                        color: '#1a202c',
                        fontWeight: '600',
                        marginBottom: '0.5rem'
                      }}>
                        {language === 'fr' ? 'Fondation d\'ASSCO' : 
                         language === 'ar' ? 'تأسيس ASSCO' : 
                         'Foundation of ASSCO'}
                      </div>
                      <div style={{ 
                        color: '#4a5568',
                        fontSize: '0.875rem',
                        lineHeight: '1.4'
                      }}>
                        {language === 'fr' ? 'Création d\'ASSCO pour fournir des solutions d\'instrumentation pour le secteur Pétrole et gaz de premier ordre en Algérie et Tunisie.' : 
                         language === 'ar' ? 'إنشاء ASSCO لتوفير حلول أجهزة القياس لقطاع النفط والغاز من الدرجة الأولى في الجزائر وتونس.' : 
                         'Creation of ASSCO to provide premier instrumentation solutions for the Oil and Gas sector in Algeria and Tunisia.'}
                      </div>
                    </div>
                  </div>
                  
                  <div className="timeline-item" style={{
                    display: 'flex',
                    marginBottom: '1.5rem',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-gray-400)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        {language === 'fr' ? '2017-Mars 2025' : language === 'ar' ? '2017-مارس 2025' : '2017-March 2025'}
                      </div>
                      <div style={{ 
                        color: '#1a202c',
                        fontWeight: '600',
                        marginBottom: '0.5rem'
                      }}>
                        {language === 'fr' ? 'Ingénieur de Service chez Baker Hughes' : 
                         language === 'ar' ? 'مهندس خدمة في Baker Hughes' : 
                         'Service Engineer at Baker Hughes'}
                      </div>
                      <div style={{ 
                        color: '#4a5568',
                        fontSize: '0.875rem',
                        lineHeight: '1.4'
                      }}>
                        {language === 'fr' ? 'Spécialisation dans les instruments de mesure de débit, de gaz et d\'humidité.' : 
                         language === 'ar' ? 'التخصص في أدوات قياس التدفق والغاز والرطوبة.' : 
                         'Specialization in flow, gas and humidity measurement instruments.'}
                      </div>
                    </div>
                  </div>
                  
                  <div className="timeline-item" style={{
                    display: 'flex',
                    marginBottom: '1.5rem',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-gray-400)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        2010-2017
                      </div>
                      <div style={{ 
                        color: '#1a202c',
                        fontWeight: '600',
                        marginBottom: '0.5rem'
                      }}>
                        {language === 'fr' ? 'GE Oil & Gas, Ingénieur Service' : 
                         language === 'ar' ? 'GE Oil & Gas، مهندس خدمة' : 
                         'GE Oil & Gas, Service Engineer'}
                      </div>
                      <div style={{ 
                        color: '#4a5568',
                        fontSize: '0.875rem',
                        lineHeight: '1.4'
                      }}>
                        {language === 'fr' ? 'Couvrant l\'Afrique du Nord pour les produits GE Sensing.' : 
                         language === 'ar' ? 'تغطية شمال إفريقيا لمنتجات GE Sensing.' : 
                         'Covering North Africa for GE Sensing products.'}
                      </div>
                    </div>
                  </div>
                  
                  <div className="timeline-item" style={{
                    display: 'flex',
                    marginBottom: '1.5rem',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-gray-400)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        2008-2010
                      </div>
                      <div style={{ 
                        color: '#1a202c',
                        fontWeight: '600',
                        marginBottom: '0.5rem'
                      }}>
                        {language === 'fr' ? 'Sous-traitant pour GE Oil & Gas' : 
                         language === 'ar' ? 'مقاول من الباطن لـ GE Oil & Gas' : 
                         'Contractor for GE Oil & Gas'}
                      </div>
                      <div style={{ 
                        color: '#4a5568',
                        fontSize: '0.875rem',
                        lineHeight: '1.4'
                      }}>
                        {language === 'fr' ? 'Travaillé en tant que sous-traitant pour GE Oil & Gas' : 
                         language === 'ar' ? 'عمل كمقاول من الباطن لـ GE Oil & Gas' : 
                         'Worked as a contractor for GE Oil & Gas'}
                      </div>
                    </div>
                  </div>
                  
                  <div className="timeline-item" style={{
                    display: 'flex',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-gray-400)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        1991-2008
                      </div>
                      <div style={{ 
                        color: '#1a202c',
                        fontWeight: '600',
                        marginBottom: '0.5rem'
                      }}>
                        {language === 'fr' ? 'Sonatrach Division Production' : 
                         language === 'ar' ? 'سوناطراك قسم الإنتاج' : 
                         'Sonatrach Production Division'}
                      </div>
                      <div style={{ 
                        color: '#4a5568',
                        fontSize: '0.875rem',
                        lineHeight: '1.4'
                      }}>
                        {language === 'fr' ? 'Expérience dans la division production de Sonatrach.' : 
                         language === 'ar' ? 'خبرة في قسم الإنتاج في سوناطراك.' : 
                         'Experience in Sonatrach production division.'}
                      </div>
                    </div>
                  </div>
                </div>
                
                <div style={{ 
                  marginTop: '2rem',
                  paddingTop: '2rem',
                  borderTop: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                  <h4 style={{ 
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    marginBottom: '1rem',
                    color: '#1a202c'
                  }}>
                    {t('about.leadership.certifications')}
                  </h4>
                  
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.75rem'
                  }}>
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                      Baker Hughes Certified
                    </span>
                    
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                      Baker Hughes Certified
                    </span>
                    
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                      Panametrics Specialist
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="leadership-card fade-in" style={{ 
            width: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            borderRadius: 'var(--radius-lg)',
            overflow: 'hidden',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.1)',
            transition: 'transform 0.3s, box-shadow 0.3s',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            animationDelay: '0.3s'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-10px)';
            e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'var(--shadow-xl)';
          }}>
            <div style={{ 
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                flex: '1 1 250px',
                backgroundColor: 'var(--assco-gray-900)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem 1.5rem',
                position: 'relative',
                overflow: 'hidden'
              }}>
                {/* Background pattern */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cpath d='M0,0 L100,0 L100,100 L0,100 Z' fill='none' stroke='%23ffffff' stroke-opacity='0.05' stroke-width='1'/%3E%3C/svg%3E")`,
                  backgroundSize: '20px 20px',
                  opacity: 0.3
                }}></div>
                
                {/* Profile image */}
                <div style={{
                  width: '140px',
                  height: '140px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--assco-gray-800)',
                  border: '3px solid var(--assco-orange)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  fontWeight: '800',
                    color: '#1a202c',
                  marginBottom: '1.5rem',
                  position: 'relative',
                  zIndex: 2,
                  boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3)'
                }}>
                  AEF
                </div>
                
                <h3 style={{ 
                  fontSize: '1.5rem',
                  color: 'white',
                  marginBottom: '0.5rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  Aimed Eddine Felfoul
                </h3>
                
                <p style={{ 
                  color: 'var(--assco-orange)',
                  fontWeight: '600',
                  fontSize: '1rem',
                  marginBottom: '1.25rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  {language === 'fr' ? 'Consultant Technique' : 
                   language === 'ar' ? 'مستشار تقني' : 
                   'Technical Consultant'}
                </p>
                
                <div style={{
                  display: 'flex',
                  gap: '1rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                    </svg>
                  </a>
                  
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                    </svg>
                  </a>
                  
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </a>
                </div>
              </div>
              
              <div style={{ 
                flex: '1 1 250px',
                padding: '3rem 2rem'
              }}>
                <h4 style={{ 
                  fontSize: '1.125rem',
                  fontWeight: '600',
                  marginBottom: '1.25rem',
                    color: '#1a202c',
                  position: 'relative',
                  paddingBottom: '0.75rem'
                }}>
                  {language === 'fr' ? 'Parcours Professionnel' : 
                   language === 'ar' ? 'المسار المهني' : 
                   'Professional Background'}
                  <span style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '50px',
                    height: '3px',
                    backgroundColor: 'var(--assco-orange)',
                    borderRadius: '1.5px'
                  }}></span>
                </h4>
                
                <div className="career-timeline">
                  <div className="timeline-item" style={{
                    display: 'flex',
                    marginBottom: '1.5rem',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-orange)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        {language === 'fr' ? 'Mai 2025 à ce jour' : language === 'ar' ? 'مايو 2025 حتى الآن' : 'May 2025 to Present'}
                      </div>
                      <div style={{ 
                        color: '#1a202c',
                        fontWeight: '600',
                        marginBottom: '0.5rem'
                      }}>
                        {language === 'fr' ? 'Consultant Technique chez ASSCO Services' : 
                         language === 'ar' ? 'مستشار تقني في ASSCO Services' : 
                         'Technical Consultant at ASSCO Services'}
                      </div>
                      <div style={{ 
                        color: '#4a5568',
                        fontSize: '0.875rem',
                        lineHeight: '1.4'
                      }}>
                        {language === 'fr' ? 'Consultant technique spécialisé pour ASSCO Services.' : 
                         language === 'ar' ? 'مستشار تقني متخصص لـ ASSCO Services.' : 
                         'Specialized technical consultant for ASSCO Services.'}
                      </div>
                    </div>
                  </div>
                  
                  <div className="timeline-item" style={{
                    display: 'flex',
                    marginBottom: '1.5rem',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-gray-400)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        {language === 'fr' ? 'Avril 2024 à ce jour' : language === 'ar' ? 'أبريل 2024 حتى الآن' : 'April 2024 to Present'}
                      </div>
                      <div style={{ 
                        color: '#1a202c',
                        fontWeight: '600',
                        marginBottom: '0.5rem'
                      }}>
                        {language === 'fr' ? 'Ingénieur Technico-commercial, IRMA Global Services' : 
                         language === 'ar' ? 'مهندس تقني تجاري، IRMA Global Services' : 
                         'Technical Sales Engineer, IRMA Global Services'}
                      </div>
                      <div style={{ 
                        color: '#4a5568',
                        fontSize: '0.875rem',
                        lineHeight: '1.4'
                      }}>
                        {language === 'fr' ? 'En charge des solutions Masoneilan Valves, soupapes de sureté Consolidated et pompes Nuovo pignon pour le secteur Pétrole et Gaz et industrie.' : 
                         language === 'ar' ? 'مسؤول عن حلول Masoneilan Valves وصمامات الأمان Consolidated ومضخات Nuovo pignon لقطاع النفط والغاز والصناعة.' : 
                         'In charge of Masoneilan Valves solutions, Consolidated safety valves and Nuovo pignon pumps for the Oil and Gas and industrial sector.'}
                      </div>
                    </div>
                  </div>
                  
                  <div className="timeline-item" style={{
                    display: 'flex',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-gray-400)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        {language === 'fr' ? 'Octobre 2023 à Mars 2024' : language === 'ar' ? 'أكتوبر 2023 إلى مارس 2024' : 'October 2023 to March 2024'}
                      </div>
                      <div style={{ 
                        color: '#1a202c',
                        fontWeight: '600',
                        marginBottom: '0.5rem'
                      }}>
                        {language === 'fr' ? 'Technicien Mécanicien Turbiniste, IRMA Global Services' : 
                         language === 'ar' ? 'فني ميكانيكي توربينات، IRMA Global Services' : 
                         'Turbine Mechanic Technician, IRMA Global Services'}
                      </div>
                      <div style={{ 
                        color: '#4a5568',
                        fontSize: '0.875rem',
                        lineHeight: '1.4'
                      }}>
                        {language === 'fr' ? 'REPARATION DE 3 turbines à Gaz ALSTOM GT26 (ARRET TECHNIQUE DE LA CENTRALE ELECTRIQUE DE TERGA)' : 
                         language === 'ar' ? 'إصلاح 3 توربينات غاز ALSTOM GT26 (التوقف الفني لمحطة كهرباء TERGA)' : 
                         'Repair of 3 ALSTOM GT26 Gas turbines (Technical shutdown of TERGA power plant)'}
                      </div>
                    </div>
                  </div>
                </div>
                
                <div style={{ 
                  marginTop: '2rem',
                  paddingTop: '2rem',
                  borderTop: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                  <h4 style={{ 
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    marginBottom: '1rem',
                    color: '#1a202c'
                  }}>
                    {language === 'fr' ? 'Domaines d\'expertise' : 
                     language === 'ar' ? 'مجالات الخبرة' : 
                     'Areas of Expertise'}
                  </h4>
                  
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.75rem'
                  }}>
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      {language === 'fr' ? 'Vannes & Soupapes' : 
                       language === 'ar' ? 'الصمامات وصمامات الأمان' : 
                       'Valves & Safety Valves'}
                    </span>
                    
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                      {language === 'fr' ? 'Turbines à Gaz' : 
                       language === 'ar' ? 'توربينات الغاز' : 
                       'Gas Turbines'}
                    </span>
                    
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                      {language === 'fr' ? 'Pompes Industrielles' : 
                       language === 'ar' ? 'المضخات الصناعية' : 
                       'Industrial Pumps'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <style jsx>{`
      .leadership-title::after {
        display: none !important;
      }
      
      @media (max-width: 1024px) {
        .leadership-card-container {
          grid-template-columns: 1fr !important;
          gap: 1.5rem !important;
          max-width: 500px !important;
        }
      }
      
      @media (max-width: 768px) {
        .leadership-card {
          margin-bottom: 1rem;
        }
        
        .leadership-card div[style*="flex: 1 1 250px"] {
          flex: 1 1 100% !important;
          padding: 1.5rem 1rem !important;
        }
        
        .leadership-card div[style*="flex: 1 1 300px"] {
          flex: 1 1 100% !important;
          padding: 1.5rem 1rem !important;
        }
      }
    `}</style>
    </>
  );
};

export default LeadershipSection;
